// document.addEventListener('DOMContentLoaded', () => {
   
//     const header = document.querySelector('.header');
//     window.addEventListener('scroll', () => {
//         const scrollPosition = window.scrollY;
//         const triggerHeight = window.innerHeight * 0.5; // 50vh

//         if (scrollPosition > triggerHeight) {
//             header.classList.add('scroll');
//         } else {
//             header.classList.remove('scroll');
//         }
//     });

// });

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.add-to-cart-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(res => res.json())
      .then(data => {
        if (window.CartDrawer) {
          window.CartDrawer.open(); 
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(err => console.error('Add to cart error:', err));
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const navItems = document.querySelectorAll(".nav-menu .nav-item");
  const activeItem = document.querySelector(".nav-menu .nav-item.active");

  if (!activeItem) return;

  navItems.forEach(item => {
    item.addEventListener("mouseenter", () => {
      if (item !== activeItem) {
        activeItem.classList.add("active-hover");
      }
    });

    item.addEventListener("mouseleave", () => {
      activeItem.classList.remove("active-hover");
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const mount = document.querySelector("#cart-bubble-mount");
  const original = document.querySelector("header-actions .cart-bubble");

  if (mount && original) {
    mount.appendChild(original);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.listing-notices-mb', {
    loop: true,
    slidesPerView:1, 
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});
// document.addEventListener('DOMContentLoaded', () => {
//   new Swiper('.listing-notices-mb', {
//     slidesPerView:1,
//     spaceBetween: 16,
//     grabCursor: true,
//     allowTouchMove: true,
//     watchOverflow: true,
//   });
// });

// document.addEventListener('DOMContentLoaded', () => {
//   const toggler = document.querySelector('.nav-toggler');
//   const nav = document.querySelector('.overlay-nav-mb');
//   if (!toggler || !nav) return;
//   toggler.addEventListener('click', () => {
//     const isOpen = nav.classList.toggle('show');
//     toggler.textContent = isOpen ? 'Close' : 'Menu';
//   });
// });

// document.addEventListener('DOMContentLoaded', () => {
//   const toggler = document.querySelector('.nav-toggler');
//   const nav = document.querySelector('.overlay-nav-mb');
//   const header = document.querySelector('.header');

//   if (!toggler || !nav || !header) return;

//   // ✅ Detect homepage
//   const isHomePage =
//     document.body.classList.contains('template-index') ||
//     window.location.pathname === '/';

//   // Toggle nav
//   toggler.addEventListener('click', () => {
//     const isOpen = nav.classList.toggle('show');
//     toggler.textContent = isOpen ? 'Close' : 'Menu';
//   });

//   let wasScrolled = false;

//   window.addEventListener('scroll', () => {
//     const triggerHeight = window.innerHeight * 0.5;
//     const isScrolled = window.scrollY > triggerHeight;

//     header.classList.toggle('scroll', isScrolled);
//     if (isHomePage && wasScrolled && !isScrolled) {
//       nav.classList.remove('show');
//       toggler.textContent = 'Menu';
//     }
//     wasScrolled = isScrolled;
//   });
// });

document.addEventListener('DOMContentLoaded', () => {
  const toggler = document.querySelector('.nav-toggler');
  const nav = document.querySelector('.overlay-nav-mb');
  const header = document.querySelector('.header');

  if (!toggler || !nav || !header) return;

  const isHomePage = document.body.classList.contains('home');

  // Toggle nav
  toggler.addEventListener('click', () => {
    const isOpen = nav.classList.toggle('show');
    toggler.textContent = isOpen ? 'Close' : 'Menu';
  });

  let wasScrolled = false;

  window.addEventListener('scroll', () => {
    const triggerHeight = window.innerHeight * 0.5;
    const isScrolled = window.scrollY > triggerHeight;

    header.classList.toggle('scroll', isScrolled);

    // 🔴 Only on HOME + only when scroll is removed
    if (isHomePage && wasScrolled && !isScrolled) {
      nav.classList.remove('show');
      toggler.textContent = 'Menu';
    }

    wasScrolled = isScrolled;
  });
});




